import React from 'react';
import { SmartphoneIcon, GlobeIcon, MessageSquareIcon, TrendingUpIcon } from 'lucide-react';
const points = [{
  id: 'convertir',
  icon: TrendingUpIcon,
  text: 'Webs diseñadas para convertir visitantes en clientes'
}, {
  id: 'whatsapp',
  icon: MessageSquareIcon,
  text: 'Conexión directa a WhatsApp y formularios'
}, {
  id: 'mobile',
  icon: SmartphoneIcon,
  text: 'Diseños optimizados para celular'
}, {
  id: 'regiones',
  icon: GlobeIcon,
  text: 'Soluciones para USA y Latinoamérica'
}];
export function TrustBar() {
  return <section aria-label="Puntos de confianza" className="border-y border-white/10 bg-ink-800" data-id="element-252" data-mp="1uxow5o41rqlm">
      <ul className="mx-auto grid max-w-page gap-6 px-5 py-10 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8 lg:px-8" data-id="element-253" data-mp="1gyfcgegmuecw">
        {points.map(point => <li key={point.id} className="flex items-start gap-3" data-id="element-254" data-mp="5k1u1p4ner49">
            <span className="mt-0.5 grid h-9 w-9 shrink-0 place-items-center rounded-lg border border-neon/30 text-neon" data-id="element-255" data-mp="5ih1u65t3k9k">
              <point.icon className="h-4 w-4" aria-hidden="true" data-id="element-256" data-mp="ags9ca8mpiom" />
            </span>
            <p className="text-sm leading-relaxed text-mist" data-id="element-257" data-mp="1aj6vx0y74rvg">{point.text}</p>
          </li>)}
      </ul>
    </section>;
}